var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo_desc"},[_vm._v(" "+_vm._s(_vm.greeting_msg)+" "),(_vm.cur_info_tool_tip_msg != null && _vm.cur_info_tool_tip_msg != '')?_c('InfoTooltip',{attrs:{"text":_vm.cur_info_tool_tip_msg}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }